import { DefaultService } from '@/services/DefaultService';

export default class OcorrenciaService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

	updateSituacao(ocorrencia, contexto = "agro") {
		return this._http.post(`${this._env}/${contexto}/ocorrencia/updatesituacao`, ocorrencia, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	findAll(column, order, page, limit, situacao, contexto = "agro", ...params) {
		return this._http.get(encodeURI(`${this._env}/${contexto}/ocorrencia.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/agro/getcombo/ocorrencia.json?param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	find(id, contexto = "agro") {
		return this._http.get(`${this._env}/${contexto}/ocorrencia/${id}.json`, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	save(form, contexto = "agro") {
		return this._http.post(`${this._env}/${contexto}/ocorrencia`, form, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

}